import React from "react";
import { ModalCrosSvg } from '../../../images/Svgs';

const DeleteUser = ({ onModalClose, onSubmit }) => {
    return (
        <div className="modal-overlay">
            <div className="modal fade show">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Delete user</h5>
                            <button type="button" className="close" onClick={() => onModalClose('')}>
                                <ModalCrosSvg />
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="event_form">
                                <h5>Are you sure you want to delete this user?</h5>
                                {/* Buttons */}
                                <div className="d-flex justify-content-end gap-2">
                                    <button type="button" className="btn btn-light" onClick={() => onModalClose('')}>
                                        Cancel
                                    </button>
                                    <button type="submit" className="btn btn-dark" onClick={() => onSubmit()}>
                                        Save
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DeleteUser;
